import { render, staticRenderFns } from "./InfoModel.vue?vue&type=template&id=27cfe46c&"
import script from "./InfoModel.vue?vue&type=script&lang=js&"
export * from "./InfoModel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports